// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var orderRouter = {
  path: '/order',
  component: Layout,
  redirect: '/order/index',
  name: 'Order',
  alwaysShow: true,
  meta: {
    title: '订单管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'aiDeviceIncome',
    component: function component() {
      return import('@/views/order/aiDeviceIncome/index');
    },
    name: 'AiDeviceIncome',
    meta: {
      title: 'AI设备订单收益',
      icon: ''
    }
  }, {
    path: 'index',
    component: function component() {
      return import('@/views/order/index');
    },
    name: 'OrderIndex',
    meta: {
      title: '订单管理'
    }
  }, {
    path: 'myList',
    component: function component() {
      return import('@/views/order/myList');
    },
    name: 'MyOrderList',
    meta: {
      title: '订单列表'
    }
  }]
};
export default orderRouter;